/**
 * Routes list
 * ORG API
 */
let _prefix = '/account/v1'
let _prefixOrg = '/orgstructure/v1'
let _prefixPay = '/payment/v1'

export default {
  signIn: _prefix + '/SignIn',
  signUp: _prefix + '/SignUp',
  signOut: _prefix + '/SignOut',
  signOutAll: _prefix + '/SignOutAll',
  signOutOne: _prefix + '/SignOutOne',
  getProfile: _prefix + '/MyProfile',
  changePass: _prefix + '/ChangePass',
  resendCode: _prefix + '/ResendCode',
  changeAuth: _prefix + '/ChangeAuth',
  confirmAuth: _prefix + '/ConfirmAuth',
  sendMessage: _prefix + '/send-message',
  updateProfile: _prefix + '/EditMyProfile',
  getSessions: _prefix + '/GetAllSessions',
  refresh: _prefix + '/Refresh',
  themes: _prefix + '/themes',
  
  // Orgstructure
  invites: _prefixOrg + '/my-invites',
  acceptInvite: _prefixOrg + '/invite-accept',
  company: _prefixOrg + '/company',

  //Payment
  rate: _prefixPay + '/rate/service/',
  history: _prefixPay + '/payment/history/',
  paymentInit: _prefixPay + '/payment/init/',
}



// WEBPACK FOOTER //
// ./src/apps/account/api/routes.js